var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnArrowRightUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 1.83341C0.539783 1.83341 0.166687 1.46032 0.166687 1.00008C0.166687 0.539844 0.539783 0.166748 1.00002 0.166748H9.33335C9.79359 0.166748 10.1667 0.539844 10.1667 1.00008V9.33342C10.1667 9.79365 9.79359 10.1667 9.33335 10.1667C8.87312 10.1667 8.50002 9.79365 8.50002 9.33342V3.01193L1.58928 9.92267C1.26384 10.2481 0.736202 10.2481 0.410765 9.92267C0.0853278 9.59723 0.0853278 9.0696 0.410765 8.74416L7.32151 1.83341H1.00002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowRightUp);
export default __webpack_public_path__ + "static/media/icn-arrow-right-up.acf5ae833d1be13ccef7c742e93bb074.svg";
export { ForwardRef as ReactComponent };